import {
  layoutMultiCampaignTasks,
  findDisconnectedComponents,
  buildDependencyGraph,
} from '../../layout';
import { getNonMilestoneTaskIds, isMilestoneNode } from '../../utils/milestoneUtils';

/**
 * Multi-campaign flowchart positions + per-campaign chain metadata for headers.
 */
export function computeMultiCampaignLayout(layoutTasks, currentNodeDimensions) {
  const tasksByCampaign = {};
  layoutTasks.forEach((task) => {
    const cid = task.sourceCampaign?.id || 'unknown';
    if (!tasksByCampaign[cid]) tasksByCampaign[cid] = [];
    tasksByCampaign[cid].push(task);
  });

  const allPositions = {};
  Object.values(tasksByCampaign).forEach((campaignTasks) => {
    campaignTasks.forEach((task) => {
      if (task.position) {
        allPositions[task.id] = { x: task.position.x, y: task.position.y };
      } else if (task.x !== undefined && task.y !== undefined) {
        allPositions[task.id] = { x: task.x, y: task.y };
      }
    });
  });

  const tasksWithPositions = layoutTasks.map((task) => ({
    ...task,
    position: allPositions[task.id] || { x: 0, y: 0 },
  }));

  const adjustedPositions = layoutMultiCampaignTasks(tasksWithPositions, currentNodeDimensions);

  const allChainInfo = [];
  Object.entries(tasksByCampaign).forEach(([campaignId, campaignTasks]) => {
    const campaignMeta = campaignTasks[0]?.sourceCampaign;
    const graph = buildDependencyGraph(campaignTasks);
    const components = findDisconnectedComponents(campaignTasks, graph);

    if (components.length > 1) {
      components.forEach((component) => {
        let minX = Infinity;
        let maxX = -Infinity;
        let minY = Infinity;
        let maxY = -Infinity;

        component.tasks.forEach((task) => {
          if (isMilestoneNode(task) || task.nodeType === 'note') return;
          const pos = adjustedPositions[task.id] || { x: 0, y: 0 };
          const dims = currentNodeDimensions[task.id] || { width: 200, height: 80 };
          minX = Math.min(minX, pos.x);
          maxX = Math.max(maxX, pos.x + dims.width);
          minY = Math.min(minY, pos.y);
          maxY = Math.max(maxY, pos.y + dims.height);
        });

        const braceTaskIds = getNonMilestoneTaskIds(component.tasks);
        if (braceTaskIds.length === 0 || minX === Infinity) return;

        allChainInfo.push({
          id: component.id,
          taskIds: braceTaskIds,
          position: { x: minX, y: minY },
          width: maxX - minX,
          campaignId,
          campaignName: campaignMeta?.name || 'Unknown',
          campaignColor: campaignMeta?.color,
        });
      });
    }
  });

  return { positions: adjustedPositions, chainInfo: allChainInfo };
}
